import DefaultModal from "components/Common/Modal/DefaultModal";
import React from "react";
import { useNavigate } from "react-router-dom";
import ModalButton from "components/Common/Modal/ModalButton";

const PortfolioGuideModal = ({ modalClose }: { modalClose: () => void }) => {
  const navigate = useNavigate();

  const handleGoToMypage = () => {
    navigate("/mypage/edit", { state: { tab: "포트폴리오" } });
    modalClose();
  };

  return (
    <DefaultModal
      handlModalClose={modalClose}
      state="error"
      title="포트폴리오가 아직 등록되지 않았어요"
      content={`다른 에이전시의 포트폴리오를 확인하려면\n내 포트폴리오를 먼저 등록해주세요.`}
      button={
        <ModalButton
          buttonType="two"
          confirmButtonText="마이페이지"
          cancelButtonText="다음에 하기"
          handleConfirm={() => {
            handleGoToMypage();
            modalClose();
          }}
          handleCancel={modalClose}
        />
      }
    >
      {/* <ButtonContainer>
        <StyledButton colorType="primary" onClick={handleGoToMypage}>
          포트폴리오 등록하러 가기
        </StyledButton>
        <StyledButton colorType="lineGray" onClick={modalClose}>
          다음에 하기
        </StyledButton>
      </ButtonContainer> */}
    </DefaultModal>
  );
};

export default PortfolioGuideModal;
